import { observer } from 'mobx-react-lite'
import { formatVisibility } from '@/features/jobs/details/amendments-card-formatters'
import { AmendmentsTable } from '@/features/jobs/details/components/AmendmentsCard/AmendmentsTable'
import { type AmendmentsTableViewModel } from './AmendmentsTableViewModel'

export interface AmendmentsTableContainerProps {
  vm: AmendmentsTableViewModel
}

export const AmendmentsTableContainer = observer(
  function AmendmentsTableContainer({ vm }: AmendmentsTableContainerProps) {
    return (
      <AmendmentsTable
        columns={vm.columns.map((col) => ({
          key: col.key,
          header: col.header,
          sortable: col.sortable,
        }))}
        currentSort={vm.sortField}
        currentSortOrder={vm.sortOrder}
        onSort={vm.setSort}
        amendments={vm.orderedAmendments.map((amendment) => ({
          description: amendment.description,
          internalNote: amendment.internalNote,
          visibilityText: formatVisibility(amendment.visibility),
          customerAmount: amendment.customerAmount,
          providerAmount: amendment.providerAmount,
          dateCreated: amendment.dateCreated,
        }))}
      />
    )
  },
)
